/**
 * Homepage FAQ — the SINGLE source of truth (Story 30.4). Consumed by both the
 * FAQSection component (visible accordion) and the FAQPage JSON-LD builder.
 * Google requires the schema to match the visible FAQ; keeping one source
 * prevents drift.
 */
import { TOTAL_INTEGRATIONS } from "../lib/integrations";

export interface FAQItem {
  question: string;
  answer: string;
}

export const HOMEPAGE_FAQS: FAQItem[] = [
  {
    question: "Is my data secure?",
    answer:
      "Absolutely. We use TLS 1.3 encryption, store all tokens securely with HttpOnly cookies, and follow OWASP best practices. Your data is tenant-isolated, no agency can ever see another agency's data. We're also fully GDPR-compliant.",
  },
  {
    question: "Which platforms do you integrate with?",
    answer: `We support ${TOTAL_INTEGRATIONS} integrations across analytics, advertising, social, SEO, reviews, and more. Connect Google Analytics 4, Search Console, Google Ads, YouTube Analytics, Meta Ads, Instagram, LinkedIn, TikTok, Microsoft Ads, Pinterest Ads, Snapchat Ads, Reddit Ads, Amazon Ads, Ahrefs, Semrush, Moz, HubSpot, Mailchimp, Klaviyo, Shopify, CallRail, Trustpilot, and more. We're adding new integrations every month.`,
  },
  {
    question: "Can I try ProvenLeap for free?",
    answer: `Yes! Our Solo plan lets you manage 1 client with all ${TOTAL_INTEGRATIONS} integrations included, no credit card required. When you're ready to grow, upgrade to Team ($49/mo), Pro ($149/mo), or Agency ($299/mo).`,
  },
  {
    question: "Can I white-label reports with my own branding?",
    answer:
      "Team and Pro plans include white-label branding so your reports look like they come directly from your agency. The Agency plan offers both white-label branding and your own custom domain for a fully branded experience.",
  },
  {
    question: "How does AI-powered reporting work?",
    answer:
      "Our AI analyzes your connected data sources and generates narrative insights, trend summaries, and actionable recommendations. With one click, you can generate a complete client report in under 30 seconds.",
  },
  {
    question: "Can I migrate from AgencyAnalytics or DashThis?",
    answer:
      "Yes. ProvenLeap supports the same major integrations as competitor platforms. Simply connect your data sources and you'll be up and running in minutes. We also offer data export so you're never locked in.",
  },
  {
    question: "What happens if I cancel?",
    answer:
      "You can cancel anytime with no penalties. Under EU Data Act compliance, you have up to 2 months notice and 30 days to export all your data. We believe in earning your business, not locking you in.",
  },
];
